export function useMatchData(liveScore, match) {
  // Scores
  const currentHomeScore = liveScore?.homeScore ?? match.homeScore ?? 0;
  const currentAwayScore = liveScore?.awayScore ?? match.awayScore ?? 0;

  // Half scores
  const currentHomeHalfScore = liveScore?.homeHalfScore ?? match.homeHalfScore ?? 0;
  const currentAwayHalfScore = liveScore?.awayHalfScore ?? match.awayHalfScore ?? 0;

  // Win status
  const isHomeWin = Number(currentHomeScore) > Number(currentAwayScore);
  const isAwayWin = Number(currentHomeScore) < Number(currentAwayScore);

  // Cards
  const homeYellow = liveScore?.homeYellow ?? match.homeYellow ?? 0;
  const homeRed = liveScore?.homeRed ?? match.homeRed ?? 0;
  const awayYellow = liveScore?.awayYellow ?? match.awayYellow ?? 0;
  const awayRed = liveScore?.awayRed ?? match.awayRed ?? 0;

  // Corners
  const currentHomeCorner = liveScore?.homeCorner ?? match.homeCorner ?? 0;
  const currentAwayCorner = liveScore?.awayCorner ?? match.awayCorner ?? 0;

  return {
    // Scores
    currentHomeScore,
    currentAwayScore,
    currentHomeHalfScore,
    currentAwayHalfScore,
    // Win status
    isHomeWin,
    isAwayWin,
    // Cards
    homeYellow,
    homeRed,
    awayYellow,
    awayRed,
    // Corners
    currentHomeCorner,
    currentAwayCorner,
  };
}